import { StaffPayScale } from '../../lib/types/models/staff-pay-scale/staff-pay-cale'
import { StaffPayScaleInput } from '../../lib/types/models/staff-pay-scale/staff-pay-scale-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createStaffPayScale(data: StaffPayScaleInput) {
  return restApiClient
    .url(constructApiUrl(API.staffPayScales.create.url, null))
    .post<StaffPayScale, StaffPayScaleInput>(data)
}
